var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('code',{staticClass:"cursor-pointer",on:{"click":_vm.copyId}},[_vm._v("ID: "+_vm._s(_vm.id))])}
var staticRenderFns = []

export { render, staticRenderFns }